'use client';

import { motion } from 'framer-motion';
import Icon from '@/components/ui/AppIcon';
import clsx from 'clsx';
import { ReactNode } from 'react';

type CTAType = 'primary' | 'secondary';

interface CTAButtonProps {
  type?: CTAType;
  label: string;
  icon?: string | ReactNode;
  onClick?: () => void;
  className?: string;
}

const baseStyles =
  'group inline-flex items-center justify-center gap-2 rounded-md px-6 py-3 sm:px-7 sm:py-3.5 font-sans text-sm sm:text-base font-semibold tracking-wide transition-colors duration-250';

const variants = {
  primary: 'bg-primary text-primary-foreground hover:bg-[#6506b8]',
  secondary: 'border border-border bg-transparent text-foreground hover:border-foreground',
};

export default function CTAButton({
  type = 'primary',
  label,
  icon,
  onClick,
  className,
}: CTAButtonProps) {
  return (
    <motion.button
      onClick={onClick}
      className={clsx(baseStyles, variants[type], className)}
      whileTap={{ scale: 0.98 }}
      transition={{ type: 'spring', stiffness: 400, damping: 25 }}
    >
      <span>{label}</span>
      {icon &&
        (typeof icon === 'string' ? (
          <Icon
            name={icon}
            size={18}
            variant="solid"
            className={clsx(
              'transition-transform duration-250',
              type === 'primary' && 'group-hover:translate-x-0.5'
            )}
          />
        ) : (
          <span
            className={clsx(
              'transition-transform duration-250',
              type === 'primary' && 'group-hover:translate-x-0.5'
            )}
          >
            {icon}
          </span>
        ))}
    </motion.button>
  );
}
